import React from 'react';

import { upsellPointsFor } from 'utilities/exam_info';

interface Props {
  aiGraded?: boolean;
  examName: string;
}

const UpsellContent = (props) => {
  const defaultPoints = [
    'Expert Video Lessons',
    'Practice Questions',
    'Score-Improvement Guarantee',
    'No Questions Asked Money-Back Guarantee'
  ];

  const points = upsellPointsFor(props.examName, 'short', props.aiGraded);

  return (
    <ul className="u-padding-L-m">
      {
        (points || defaultPoints).map((point, idx) => (
          <li key={idx}>{point}</li>
        ))
      }
    </ul>
  );
};

export default UpsellContent;
